import Vue from 'vue'
import axios from "axios"
import api from '../api'
import router from "@/router"
import {getEstimatedDate, _Parse_Number} from "@/utils";

function _Safe_Print () {
  window.print()
}

// Extrage numele fisierului din header-ul Content-Disposition trimis de BE.
// Daca header-ul lipseste sau nu are filename, intoarce fallback-ul primit.
function _Get_Filename_From_Disposition (headers, fallback) {
  const cd = headers && headers['content-disposition'];
  if (cd) {
    const match = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(cd);
    if (match && match[1]) {
      return decodeURIComponent(match[1]);
    }
  }
  return fallback;
}

const comanda = {
  cerinte_client: '<div></div>',
  nota_constatare: '<div></div>',
  defectiuni: '<div></div>',
  asigurator: '<div></div>',
  lucrari: '<div></div>',
  piese_client: '<div></div>',
  observatii: '<div></div>',
  mecanic: '<div></div>',
  termen_estimativ: getEstimatedDate(),
  nota: '<div>Subsemnatul, parcipant la constatarea efectuata de reprezentatul SERVICE, am luat la cunostinta de cele mentionate in prezenta si am primit un exemplar. In cazul in care la efectuarea reparatiilor la vehiculul mentionat mai sus rezulta si alte repere neconstatate in prezenta nota, beneficiarul poate solicita o noua reconstatare. SERVICE-ul nu raspunde pentru obiectele personale lasate in masina. Masinile fabricate pana in 2012 datorita vechimii, au risc ridicat ca la demontare sa apara alte probleme cu prezoanele, suruburile si piulitele ruginite. Nu raspundem si nu ne asumam riscul la aceste probleme.</div>',
  date: new Date()
}

export const state = {
  comenzi: [],
  pagination: {
    total: 0,
    page: 1,
    limit: 10
  },
  comandaTemplate: {
    car: {},
    comanda,
    deviz: [{}, {}, {}],
    client: {}
  },
  comanda: {
    car: {},
    comanda,
    deviz: [{}, {}, {}],
    client: {},
    deviz_date: new Date(),
    booking_date: undefined,
    booking_time: undefined,
    invoiced: false,
    invoice_id: undefined,
    invoice_pdf_url: undefined,
    dosar_dauna: false,
    mechanicId: null,
    rampId: null,
    statusId: null,
    documents: [],
  },
  formularComanda: comanda,
  intrariRar: [],
  devizTotalStaticValues: [],
  deviz: {
    parts: [],
    manopera: [],
    materiale: []
  },
  deviz_oferta: {
    parts: [],
    manopera: []
  },
  is_request: false,
  loading: false,
  // Afișează modalul global „deviz gol" la facturare (în loc de toast). Setat de
  // acțiunile de emitere pe 400 „factură goală", golit când userul închide modalul.
  emptyInvoiceNotice: false,
}

export const mutations = {
  SET_EMPTY_INVOICE_NOTICE (state, value) {
    state.emptyInvoiceNotice = value;
  },
  SET_COMANDA (state, comanda) {
    state.emptyInvoiceNotice = false;
    state.deviz.parts = [];
    state.deviz.manopera = [];
    state.deviz.materiale = [];
    comanda.deviz.forEach(obj => {
      if (obj.manopera) {
        obj.total = obj.total || Math.round((+obj.pretUnitate || 0) * (+obj.durata || 0));
        obj.denumire && state.deviz.manopera.push(obj);
      } else if (obj.materiale) {
        obj.total = obj.total || Math.round((+obj.pretUnitate || 0) * (+obj.durata || 0));
        obj.denumire && state.deviz.materiale.push(obj);
      } else {
        obj.denumire && state.deviz.parts.push(obj);
      }
    })

    if (!comanda.comanda.termen_estimativ || comanda.comanda.termen_estimativ === '<div></div>') {
      comanda.comanda.termen_estimativ = getEstimatedDate()
    }

    if (comanda.dosar_dauna === undefined) {
      comanda.dosar_dauna = false
    }

    if (comanda.mechanicId === undefined) {
      comanda.mechanicId = null
    }

    if (comanda.rampId === undefined) {
      comanda.rampId = null
    }

    if (comanda.statusId === undefined) {
      comanda.statusId = null
    }

    if (comanda.comanda.asigurator === undefined) {
      comanda.comanda.asigurator = '<div></div>'
    }

    // Ensure booking keys exist BEFORE the object becomes reactive, otherwise
    // later mutations on state.comanda.booking_* won't retrigger dependencies.
    if (!('booking_date' in comanda)) comanda.booking_date = undefined
    if (!('booking_time' in comanda)) comanda.booking_time = undefined
    if (!('appointment_date' in comanda)) comanda.appointment_date = undefined

    if (!comanda.documents) comanda.documents = []
    comanda.documents = comanda.documents.map(doc => ({
      ...doc,
      url: doc.url || `${api.uploads}/${doc.stored_filename}`
    }))

    state.comanda = comanda;
  },
  ADD_COMANDA_DOCUMENT (state, document) {
    if (!state.comanda.documents) Vue.set(state.comanda, 'documents', [])
    state.comanda.documents.push(document)
  },
  REMOVE_COMANDA_DOCUMENT (state, storedFilename) {
    state.comanda.documents = (state.comanda.documents || []).filter(doc => doc.stored_filename !== storedFilename)
  },
  SET_RAR_ENTRIES (state, value) {
    state.intrariRar = value
  },
  SET_CAR_FIELD_VALUE (state, {name, value}) {
    Vue.set(state.comanda.car, name, value)
  },
  SET_CAR_DETAILS (state, details) {
    // we fill only the static values
    const fields = ['numar', 'marca', 'model', 'sasiu', 'carburant', 'cilindree', 'putere', 'cod_motor', 'culoare', 'an', 'itp'];
    fields.forEach(val => {
      Vue.set(state.comanda.car, val, details[val])
    })
  },
  SET_CLIENT_FIELD_VALUE (state, {name, value}) {
    Vue.set(state.comanda.client, name, value)
  },
  SET_CLIENT_COMPANY_DATA (state, payload = {}) {
    // Maps the ANAF/registry lookup response onto the client form fields.
    // `nr_reg` from the response is intentionally ignored (no UI field for it).
    // `cui` is left untouched — the user's input drove the lookup.
    Vue.set(state.comanda.client, 'numeFirma',   payload.denumire || '')
    Vue.set(state.comanda.client, 'adresaFirma', payload.adresa   || '')
    Vue.set(state.comanda.client, 'city',        payload.city     || '')
    Vue.set(state.comanda.client, 'state',       payload.state    || '')
  },
  SET_DEVIZ_FIELD_VALUE (state, {tableName, index, value, field}) {
    Vue.set(state.deviz[tableName][index], field, value);
  },
  SET_DEVIZ_FIELD_VALUE_DEVIZ_OFERTA (state, {tableName, index, value, field}) {
    Vue.set(state.deviz_oferta[tableName][index], field || 'denumire', value);
  },
  RESET_FORMULAR_INTRARE_NOUA (state) {
    state.comanda = {
      car: {},
      comanda: {
        cerinte_client: '<div></div>',
        nota_constatare: '<div></div>',
        defectiuni: '<div></div>',
        asigurator: '<div></div>',
        lucrari: '<div></div>',
        piese_client: '<div></div>',
        observatii: '<div></div>',
        mecanic: '<div></div>',
        termen_estimativ: '<div></div>',
        nota: '<div>Subsemnatul, parcipant la constatarea efectuata de reprezentatul SERVICE, am luat la cunostinta de cele mentionate in prezenta si am primit un exemplar. In cazul in care la efectuarea reparatiilor la vehiculul mentionat mai sus rezulta si alte repere neconstatate in prezenta nota, beneficiarul poate solicita o noua reconstatare. SERVICE-ul nu raspunde pentru obiectele personale lasate in masina. Masinile fabricate pana in 2012 datorita vechimii, au risc ridicat ca la demontare sa apara alte probleme cu prezoanele, suruburile si piulitele ruginite. Nu raspundem si nu ne asumam riscul la aceste probleme.</div>',
        date: new Date()
      },
      deviz: [{}, {}, {}],
      client: {},
      dosar_dauna: false,
      mechanicId: null,
      rampId: null,
      statusId: null,
      booking_date: undefined,
      booking_time: undefined,
      documents: []
    }
  },
  STRIP_EMPTY_FIELDS_DEVIZ (state) {
    const deviz = state.comanda.deviz.filter(({denumire, durata, pretUnitate}) => denumire && durata && pretUnitate)
    Vue.set(state.comanda, 'deviz', deviz)
  },
  SET_COMENZI (state, payload) {
    const items = Array.isArray(payload) ? payload : (payload && payload.items) || []
    Vue.set(state, 'comenzi', items)
    if (payload && !Array.isArray(payload)) {
      Vue.set(state, 'pagination', {
        total: +payload.total || 0,
        page: +payload.page || 1,
        limit: +payload.limit || 10
      })
    }
  },
  // Patch-uiește statusul unei singure comenzi din listă. Setăm ambele variante
  // de câmp (status_id/statusId) ca să prindă resolver-ul din Comenzi.vue
  // (status_id || statusId) și golim `status`-ul embedat ca să nu umbrească
  // ștergerea statusului (status null => placeholder în celulă).
  SET_COMANDA_STATUS (state, { id, statusId }) {
    const item = state.comenzi.find(c => c._id === id)
    if (!item) return
    Vue.set(item, 'statusId', statusId)
    Vue.set(item, 'status_id', statusId)
    Vue.set(item, 'status', null)
  },
  REMOVE_LAST_DEFECT (state) {
    state.comanda.comanda.fields.pop()
  },
  ADD_MANOPERA (state, index) {
    Vue.set(state.comanda.deviz[index], 'manopera', !state.comanda.deviz[index].manopera)
  },
  ADD_DEFECT (state) {
    state.comanda.comanda.fields.push(undefined)
  },
  ADD_PARTS_DEVIZ_FIELD (state) {
    state.deviz.parts.push({denumire: '', total: 0, pretUnitate: 0, durata: 1, um: ''});
  },
  ADD_MATERIALE_DEVIZ_FIELD (state) {
    state.deviz.materiale.push({denumire: '', materiale: true, total: 0, pretUnitate: 0, durata: 1, um: ''});
  },
  ADD_PARTS_DEVIZ_FIELD_DEVIZ_OFERTA (state) {
    state.deviz_oferta.parts.push({denumire: '', total: 0, pretUnitate: 0, durata: 1});
  },
  ADD_MANOPERA_DEVIZ_SIMPLU_FIELD (state, { manopera: pretUnitate, tva }) {
    state.deviz.manopera.push({
      denumire: '',
      manopera: true,
      pretUnitate,
      total: +pretUnitate,
      durata: 1
    });
  },
  ADD_MANOPERA_DEVIZ_FIELD (state, { manopera: pretUnitate, tva }) {
    state.deviz.manopera.push({
      denumire: '',
      manopera: true,
      pretUnitate,
      total: (+pretUnitate + (+pretUnitate * +`0.${tva}`)).toFixed(2),
      durata: 1
    });
  },
  ADD_MANOPERA_DEVIZ_FIELD_DEVIZ_OFERTA (state, { manopera: pretUnitate, tva }) {
    state.deviz_oferta.manopera.push({
      denumire: '',
      manopera: true,
      pretUnitate,
      total: (+pretUnitate + (+pretUnitate * +`0.${tva}`)).toFixed(2),
      durata: 1
    });
  },
  UPDATE_COMANDA_HTML_FIELD (state, {key, htmlVal}) {
    Vue.set(state.comanda.comanda, key, htmlVal)
  },
  UPDATE_COMANDA_NOUA_FIELD (state, {key, value}) {
    Vue.set(state.comanda, key, value);
  },
  SET_DEVIZ_ITEM_DURATA (state, {value, index, tableName}) {
    // modify the total
    const item = state.deviz[tableName][index];
    state.deviz[tableName][index].durata = value;
    state.deviz[tableName][index].total = convertTimeToPrice(value, _Parse_Number(item.pretUnitate));
  },
  SET_DEVIZ_ITEM_DURATA_DEVIZ_OFERTA (state, {value, index, tableName}) {
    // modify the total
    const item = state.deviz_oferta[tableName][index];
    state.deviz_oferta[tableName][index].durata = value;
    state.deviz_oferta[tableName][index].total = convertTimeToPrice(value, _Parse_Number(item.pretUnitate));
  },
  SET_DEVIZ_ITEM_PRET_UNITATE (state, {value, index, tableName, tva}) {
    // modify the total
    state.deviz[tableName][index].pretUnitate = value;
    const durata = state.deviz[tableName][index].durata;
    const price = _Parse_Number(value);
    const decimalHours = _Parse_Number(durata);
    const tvaRate = _Parse_Number(tva);
    state.deviz[tableName][index].total = ((price * decimalHours) + (price * decimalHours * tvaRate / 100)).toFixed(2);
  },
  SET_DEVIZ_ITEM_PRET_UNITATE_DEVIZ_OFERTA (state, {value, index, tableName, tva}) {
    // modify the total
    state.deviz_oferta[tableName][index].pretUnitate = value;
    const durata = state.deviz_oferta[tableName][index].durata;
    const price = _Parse_Number(value);
    const decimalHours = _Parse_Number(durata);
    const tvaRate = _Parse_Number(tva);
    state.deviz_oferta[tableName][index].total = ((price * decimalHours) + (price * decimalHours * tvaRate / 100)).toFixed(2);
  },
  SET_DEVIZ_ITEM_PRET_UNITATE_MANOPERA (state, {value, index, tableName}) {
    // modify the total
    const item = state.deviz[tableName][index];
    state.deviz[tableName][index].pretUnitate = value;
    state.deviz[tableName][index].total = convertTimeToPrice(item.durata, _Parse_Number(value));
  },
  SET_DEVIZ_ITEM_PRET_UNITATE_FARA_TVA (state, {value, index, tableName, tva}) {
    const total = _Parse_Number(value);
    state.deviz[tableName][index].total = total;
    const quantity = _Parse_Number(state.deviz[tableName][index].durata);
    const tvaRate = _Parse_Number(tva);
    const pretUnitate = quantity ? ((total / (1 + tvaRate / 100)) / quantity).toFixed(2) : '0.00';
    state.deviz[tableName][index].pretUnitate = pretUnitate;
  },
  SET_DEVIZ_ITEM_PRET_UNITATE_FARA_TVA_DEVIZ_OFERTA (state, {value, index, tableName, tva}) {
    const total = _Parse_Number(value);
    state.deviz_oferta[tableName][index].total = total;
    const quantity = _Parse_Number(state.deviz_oferta[tableName][index].durata);
    const tvaRate = _Parse_Number(tva);
    const pretUnitate = quantity ? ((total / (1 + tvaRate / 100)) / quantity).toFixed(2) : '0.00';
    state.deviz_oferta[tableName][index].pretUnitate = pretUnitate;
  },
  SET_DEVIZ_SIMPLU_MANOPERA_ITEM_TOTAL (state, {value, index, tva}) {
    const total = _Parse_Number(value);
    state.deviz.manopera[index].total = total;
    const pretOra = _Parse_Number(state.deviz.manopera[index].pretUnitate);
    state.deviz.manopera[index].durata = pretOra ? +(total / pretOra).toFixed(2) : 0;
  },
  SET_DEVIZ_MANOPERA_ITEM_TOTAL (state, {value, index, tva}) {
    const total = _Parse_Number(value);
    state.deviz.manopera[index].total = total;
    const pretUnitate = _Parse_Number(state.deviz.manopera[index].pretUnitate);
    const tvaRate = _Parse_Number(tva);
    if (!pretUnitate) {
      state.deviz.manopera[index].durata = 0;
      return;
    }
    const durata = (total / (1 + tvaRate / 100)) / pretUnitate;
    state.deviz.manopera[index].durata = durata.toString().length > 1
      ? durata.toFixed(2)
      : durata;
  },
  SET_DEVIZ_MANOPERA_ITEM_TOTAL_DEVIZ_OFERTA (state, {value, index, tva}) {
    const total = _Parse_Number(value);
    state.deviz_oferta.manopera[index].total = total;
    const pretUnitate = _Parse_Number(state.deviz_oferta.manopera[index].pretUnitate);
    const tvaRate = _Parse_Number(tva);
    if (!pretUnitate) {
      state.deviz_oferta.manopera[index].durata = 0;
      return;
    }
    const durata = (total / (1 + tvaRate / 100)) / pretUnitate;
    state.deviz_oferta.manopera[index].durata = durata.toString().length > 1
      ? durata.toFixed(2)
      : durata;
  },
  SET_DEVIZ_ITEM_VALOARE_TOTALA (state, {index, tableName, tva}) {
    const PU = _Parse_Number(state.deviz[tableName][index].pretUnitate);
    const quantity = _Parse_Number(state.deviz[tableName][index].durata);
    const tvaRate = _Parse_Number(tva);
    state.deviz[tableName][index].total = ((PU * quantity) + (PU * quantity * tvaRate / 100)).toFixed(2);
  },
  SET_DEVIZ_ITEM_VALOARE_TOTALA_DEVIZ_OFERTA (state, {index, tableName, tva}) {
    const PU = _Parse_Number(state.deviz_oferta[tableName][index].pretUnitate);
    const quantity = _Parse_Number(state.deviz_oferta[tableName][index].durata);
    const tvaRate = _Parse_Number(tva);
    state.deviz_oferta[tableName][index].total = ((PU * quantity) + (PU * quantity * tvaRate / 100)).toFixed(2);
  },
  HANDLE_DURATA_PIESE (state, {value, index, tva}) {
    const qty = _Parse_Number(value);
    // Ignore the blank keystroke that happens when the user clears the field
    // before typing the new quantity — committing it here would overwrite
    // durata/total and destroy the reference needed to scale proportionally.
    if (!qty) return;
    const item = state.deviz.parts[index];
    const oldQty = _Parse_Number(item.durata);
    const oldTotal = _Parse_Number(item.total);
    item.durata = value;
    if (oldQty && oldTotal) {
      item.total = (oldTotal / oldQty * qty).toFixed(2);
      return;
    }
    const price = _Parse_Number(item.pretUnitate);
    const tvaRate = _Parse_Number(tva);
    item.total = ((price * qty) + (price * qty * tvaRate / 100)).toFixed(2);
  },
  HANDLE_DURATA_MATERIALE (state, {value, index, tva}) {
    const { pretUnitate } = state.deviz.materiale[index];
    const price = _Parse_Number(pretUnitate);
    const qty = _Parse_Number(value);
    const tvaRate = _Parse_Number(tva);
    state.deviz.materiale[index].durata = value;
    state.deviz.materiale[index].total = ((price * qty) + (price * qty * tvaRate / 100)).toFixed(2);
  },
  HANDLE_DURATA_PIESE_DEVIZ_OFERTA (state, {value, index, tva}) {
    const { pretUnitate } = state.deviz_oferta.parts[index];
    const price = _Parse_Number(pretUnitate);
    const qty = _Parse_Number(value);
    const tvaRate = _Parse_Number(tva);
    state.deviz_oferta.parts[index].durata = value;
    state.deviz_oferta.parts[index].total = ((price * qty) + (price * qty * tvaRate / 100)).toFixed(2);
  },
  HANDLE_DELETE_ROW (state, {tableName, index}) {
    state.deviz[tableName].splice(index, 1);
  },
  HANDLE_DELETE_ROW_DEVIZ_OFERTA (state, {tableName, index}) {
    state.deviz_oferta[tableName].splice(index, 1);
  },
  RESET_DEVIZ_DATA (state) {
    state.deviz = {
      parts: [],
      manopera: [],
      materiale: []
    }
  },
  RESET_DEVIZ_AUTO_TEXT_FIELDS (state) {
    state.comanda.lucrari_solicitate = ''
    state.comanda.piese_furnizate_client = ''
    state.comanda.defecte_suplimentare = ''
    state.comanda.accept_client = ''
    state.comanda.accept_client_semnatura = ''
    state.comanda.termen_executie = ''
    state.comanda.cost_estimativ = ''
    state.comanda.presiune_anvelope = ''
    state.comanda.cuplu_strangere = ''
    // model3 fields
    state.comanda.lucrari_efectuate = ''
    state.comanda.piese_materiale = ''
    state.comanda.cost_total = ''
    state.comanda.executant = ''
    state.comanda.nume_inspector = ''
  },
  RESET_DEVIZ_DATA_DEVIZ_OFERTA (state) {
    state.deviz_oferta = {
      parts: [],
      manopera: []
    }
  },
  HANDLE_DURATA_MANOPERA (state, {value, index, tva}) {
    const hours = _Parse_Number(value);
    // Ignore the blank keystroke that happens when the user clears the field
    // before typing the new hours — committing it here would overwrite
    // durata/total and destroy the reference needed to scale proportionally.
    if (!hours) return;
    const item = state.deviz.manopera[index];
    const oldHours = _Parse_Number(item.durata);
    const oldTotal = _Parse_Number(item.total);
    if (oldHours && oldTotal) {
      Vue.set(item, 'durata', value);
      Vue.set(item, 'total', (oldTotal / oldHours * hours).toFixed(2));
      return;
    }
    const price = _Parse_Number(item.pretUnitate);
    const tvaRate = _Parse_Number(tva);
    const total = (hours * price) + (hours * price * tvaRate / 100);
    Vue.set(item, 'durata', value);
    Vue.set(item, 'total', total.toFixed(2));
  },
  HANDLE_DURATA_MANOPERA_DEVIZ_OFERTA (state, {value, index, tva}) {
    const { pretUnitate } = state.deviz_oferta.manopera[index];
    const hours = _Parse_Number(value);
    const price = _Parse_Number(pretUnitate);
    const tvaRate = _Parse_Number(tva);
    const total = (hours * price) + (hours * price * tvaRate / 100);
    Vue.set(state.deviz_oferta.manopera[index], 'durata', value);
    Vue.set(state.deviz_oferta.manopera[index], 'total', total.toFixed(2));
  },
  SET_DEVIZ_OFERTA (state, comanda) {
    state.deviz_oferta.parts = [];
    state.deviz_oferta.manopera = [];
    if (!comanda.documents) comanda.documents = []
    comanda.deviz_oferta.forEach(obj => {
      if (obj.manopera) {
        obj.total = obj.total || Math.round((+obj.pretUnitate || 0) * (+obj.durata || 0));
        obj.denumire && state.deviz_oferta.manopera.push(obj);
      } else {
        obj.denumire && state.deviz_oferta.parts.push(obj);
      }
    })
    state.comanda = comanda;
  },
  MARK_DEVIZ_INVOICED (state, filename) {
    state.comanda.invoiced = true;
    state.comanda.invoice_id = filename.replace('.pdf', '');
  },
  MARK_DEVIZ_SMARTBILL_INVOICED (state, { invoice_id, invoice_series, invoice_pdf_url }) {
    state.comanda.invoiced = true;
    state.comanda.invoice_id = invoice_id;
    state.comanda.invoice_series = invoice_series;
    state.comanda.invoice_pdf_url = invoice_pdf_url || undefined;
  },

  SET_IS_REQUEST (state,payload) {
    state.is_request = payload
  },

  SET_LOADING (state, payload) {
    state.loading = payload
  },
}

// Derive the 3-line client_info string sent to the BE for Deviz Model 3
// from the intrare client fields. Keeps client_info in sync with intrare
// without storing it as a separate editable field.
function _Derive_Client_Info (client) {
  const c = client || {}
  const line3 = [c.city, c.state].filter(Boolean).join(', ')
  return [c.nume || '', c.adresaFirma || '', line3].join('\n')
}

export const actions = {
  async lookup_company_by_cui ({ commit }, payload) {
    // Accepts either a raw CUI string (client lookups) or { cui, vat } — the
    // Settings firma lookup passes vat:1 so the BE also persists the TVA flags.
    const cui = typeof payload === 'string' ? payload : payload.cui
    const vat = typeof payload === 'object' && payload.vat ? '&vat=1' : ''
    // Rethrows on failure so the caller can differentiate 404 (CUI not found)
    // from other errors and surface the right inline message.
    const { data } = await axios.get(
      `${api.lookup_cui}?cui=${encodeURIComponent(cui)}${vat}`
    )
    commit('SET_CLIENT_COMPANY_DATA', data)
    return data
  },
  async scan_talon ({ commit }, file) {
    const formData = new FormData()
    formData.append('talon', file)
    const { data } = await axios.post(api.scan_talon, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    if (data && data.car) {
      commit('SET_CAR_DETAILS', data.car)
    }
    if (data && data.client) {
      if (data.client.proprietar !== undefined) {
        commit('SET_CLIENT_FIELD_VALUE', { name: 'proprietar', value: data.client.proprietar })
      }
      if (data.client.nume !== undefined) {
        commit('SET_CLIENT_FIELD_VALUE', { name: 'nume', value: data.client.nume })
      }
    }
    return data
  },
  async get_comenzi ({state, commit}) {
    commit('SET_LOADING', true)
    try {
      const params = router.currentRoute.query
      const { data } = await axios(api.comenzi, {
        params
      });
      commit('SET_COMENZI', data);
    } catch (e) {
      state.error = 'Eroare primire comenzi din server.'
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async save_comanda ({state, commit}, options = {}) {
    try {
      const { data } = await axios.post(api.comanda_noua, state.comanda);
      const route = options.route_to ? `${options.route_to}/${data._id}` : 'comenzi';
      await router.push(`/${route}`);
    } catch (e) {
      if (e?.response?.status === 403) {
        commit('SET_TRIAL_EXPIRED_MODAL', true, { root: true })
        return
      }
      state.error = 'Eroare salvare comanda.'
    }
  },
  async get_comanda ({ state, commit }, id) {
    try {
      const { data } = await axios(`${api.comenzi}/get-comanda/${id}`);
      // because deviz_date was added later, all data until this date
      // do now have this value so we eq to comanda date
      if (!data.deviz_date) {
        data.deviz_date = data.comanda.date;
      }
      const route_name = router.currentRoute.name;
      route_name === 'Deviz-Oferta'
        ? commit('SET_DEVIZ_OFERTA', data)
        : commit('SET_COMANDA', data)
    }
    catch (e) {
      state.error = 'Eroare primire comenzi din server.'
    }
  },
  async upload_document ({ state, commit }, file) {
    const formData = new FormData()
    formData.append('document', file)
    const { data } = await axios.post(`${api.comenzi}/${state.comanda._id}/document`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    commit('ADD_COMANDA_DOCUMENT', { ...data.document, url: data.url })
    return data
  },
  async delete_document ({ state, commit }, storedFilename) {
    await axios.delete(`${api.comenzi}/${state.comanda._id}/document`, {
      params: { filename: storedFilename }
    })
    commit('REMOVE_COMANDA_DOCUMENT', storedFilename)
  },
  async update_comanda ({ state }, id) {
    try {
      const url = `${api.update_comanda}/${id}`
      await axios.put(url, state.comanda)
      await router.push({ path: '/comenzi', query: router.currentRoute.query })
    } catch (e) {
      state.error = 'Eroare salvare comanda.'
    }
  },
  // Schimbă doar statusul unei comenzi direct din listă (dropdown inline).
  // Folosește același EP ca update_comanda (PUT /api/comenzi/update/:id), dar
  // trimite doar { statusId } și patch-uiește local — fără GET-ul comenzii, fără
  // navigare. Optimist: aplicăm imediat, revenim la valoarea veche dacă pică.
  async update_comanda_status ({ commit, state }, { id, statusId }) {
    const prev = state.comenzi.find(c => c._id === id)
    const prevStatusId = prev ? (prev.status_id || prev.statusId || null) : null
    commit('SET_COMANDA_STATUS', { id, statusId })
    try {
      await axios.put(`${api.update_comanda}/${id}`, { statusId })
    } catch (e) {
      commit('SET_COMANDA_STATUS', { id, statusId: prevStatusId })
      throw e
    }
  },
  async save_booking ({ state }) {
    try {
      const url = `${api.comenzi}/${state.comanda._id}/booking`
      const payload = {
        booking_date: state.comanda.booking_date,
        booking_time: state.comanda.booking_time
      }
      await axios.post(url, payload)
      return true
    } catch (e) {
      state.error = 'Eroare salvare programare.'
      return false
    }
  },
  async save_formular_comanda ({state}, action) {
    try {
      const url = `${api.save_formular_comanda}/${state.comanda._id}`
      await axios.post(url, state.comanda)
      switch (action) {
        case 'print':
          await _Safe_Print()
          break
        case 'save':
        case 'pdf':
          break
        default:
          window.history.back()
      }
    } catch (e) {
      state.error = 'Eroare salvare comanda.'
    }
  },
  async save_deviz ({state, commit, dispatch, rootState}, action) {
    commit('STRIP_EMPTY_FIELDS_DEVIZ');
    commit('SET_REQ_IN_PROGRESS_NAME', `save_deviz_${action}`);
    try {
      const url = `${api.save_deviz}/${state.comanda._id}`;
      const payload = {
        car: state.comanda.car,
        client: state.comanda.client,
        deviz_date: state.comanda.deviz_date,
        items: [
          ...state.deviz.parts.map(i => ({ ...i })),
          ...state.deviz.manopera.map(i => ({ ...i })),
          ...(state.deviz.materiale || []).map(i => ({ ...i })),
        ],
        lucrari_solicitate: state.comanda.lucrari_solicitate,
        piese_furnizate_client: state.comanda.piese_furnizate_client,
        defecte_suplimentare: state.comanda.defecte_suplimentare,
        accept_client: state.comanda.accept_client,
        accept_client_semnatura: state.comanda.accept_client_semnatura,
        termen_executie: state.comanda.termen_executie,
        cost_estimativ: state.comanda.cost_estimativ,
        presiune_anvelope: state.comanda.presiune_anvelope,
        cuplu_strangere_roti: state.comanda.cuplu_strangere_roti,
        lucrari_efectuate: state.comanda.lucrari_efectuate,
        piese_materiale: state.comanda.piese_materiale,
        cost_total: state.comanda.cost_total,
        executant: state.comanda.executant,
        nume_inspector: state.comanda.nume_inspector,
        client_info: state.comanda.client_info,
      };
      await axios.post(url, payload);
      switch (action) {
        case 'print':
          if (rootState.setari.settings.deviz_conditii_contract) {
            await dispatch('fetch_conditii_contract');
            await Vue.nextTick();
          }
          await _Safe_Print();
          break;
        case 'back':
          window.history.back();
          break;
        case 'comenzi':
          await router.push('/comenzi');
          break;
        default:
          break;
      }
    } catch (e) {
      state.error = 'Eroare salvare comanda.'
    } finally {
      commit('SET_REQ_IN_PROGRESS_NAME', '');
    }
  },
  async save_deviz_custom ({state, commit, dispatch, rootState}, action) {
    commit('STRIP_EMPTY_FIELDS_DEVIZ');
    try {
      const url = `${api.save_deviz_custom}/${state.comanda._id}`;
      const _to_base_total = item => ({
        ...item,
        total: +(Number(item.durata || 0) * Number(item.pretUnitate || 0)).toFixed(2)
      });
      const items = [
        ...state.deviz.parts.map(_to_base_total),
        ...state.deviz.manopera.map(i => ({ ..._to_base_total(i), manopera: true })),
        ...(state.deviz.materiale || []).map(i => ({ ..._to_base_total(i), materiale: true })),
      ];
      const payload = {
        car: state.comanda.car,
        client: state.comanda.client,
        deviz_date: state.comanda.deviz_date,
        items,
        lucrari_solicitate: state.comanda.lucrari_solicitate,
        piese_furnizate_client: state.comanda.piese_furnizate_client,
        defecte_suplimentare: state.comanda.defecte_suplimentare,
        accept_client: state.comanda.accept_client,
        accept_client_semnatura: state.comanda.accept_client_semnatura,
        termen_executie: state.comanda.termen_executie,
        cost_estimativ: state.comanda.cost_estimativ,
        presiune_anvelope: state.comanda.presiune_anvelope,
        cuplu_strangere: state.comanda.cuplu_strangere,
        lucrari_efectuate: state.comanda.lucrari_efectuate,
        piese_materiale: state.comanda.piese_materiale,
        cost_total: state.comanda.cost_total,
        executant: state.comanda.executant,
        nume_inspector: state.comanda.nume_inspector,
        client_info: _Derive_Client_Info(state.comanda.client),
      };
      await axios.post(url, payload);
      switch (action) {
        case 'print':
          if (rootState.setari.settings.deviz_conditii_contract) {
            await dispatch('fetch_conditii_contract');
            await Vue.nextTick();
          }
          await _Safe_Print();
          break;
        case 'back':
          window.history.back();
          break;
        case 'comenzi':
          await router.push('/comenzi');
          break;
        default:
          break;
      }
    } catch (e) {
      state.error = 'Eroare salvare comanda.'
    }
  },
  async save_deviz_oferta ({state, commit, dispatch, rootState}, { action } = {}) {
    commit('STRIP_EMPTY_FIELDS_DEVIZ');
    try {
      const _id = state.comanda._id || router.currentRoute.params.id;
      const url = `${api.save_deviz}/${_id}`;
      const payload = {
        deviz_oferta: true,
        items: [...state.deviz_oferta.parts, ...state.deviz_oferta.manopera],
      };
      await axios.post(url, payload);
      switch (action) {
        case 'print':
          if (rootState.setari.settings.deviz_conditii_contract) {
            await dispatch('fetch_conditii_contract');
            await Vue.nextTick();
          }
          await _Safe_Print();
          break;
        case 'back':
          window.history.back();
          break;
        default:
          break;
      }
      return true;
    } catch (e) {
      state.error = 'Eroare salvare comanda.'
    }
  },
  // Deviz PDF ca blob, fără side-effects (pentru previzualizare în modal).
  // Varianta de endpoint depinde de modelul devizului, la fel ca `make_pdf`.
  async fetch_deviz_pdf (_ctx, { id, type } = {}) {
    if (!id) return null
    let url
    if (type === 'model_1') url = `${api.download_pdf_custom}/${id}`
    else if (type === 'model_3') url = `${api.download_pdf_custom_2}/${id}`
    else url = `/api/download-pdf/${id}`
    return axios.get(url, { responseType: 'blob' })
  },
  async make_pdf ({state, commit}, payload = {}) {
    try {
      commit('SET_IS_REQUEST', true)
      let url;
      if (payload.custom) {
        url = `/api/download-pdf-custom/${payload.id}`;
      } else if (payload.oferta) {
        url = `/api/download-pdf/${payload.id}?oferta=true`;
      } else {
        url = `/api/download-pdf/${payload.id}`;
      }
      commit('SET_REQ_IN_PROGRESS_NAME', 'download_pdf');
      const { data, headers } = await axios.get(url, { responseType: 'arraybuffer' });
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      commit('SET_IS_REQUEST', false)

      const pdfBlob = new Blob([data], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // If payload.pdf is true → download instead of open
      if (payload.pdf === true) {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');

        const fileName = _Get_Filename_From_Disposition(headers, `Deviz_${yyyy}-${mm}-${dd}.pdf`);

        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(pdfUrl);
        payload.clbk && payload.clbk();
        return; // stop here
      }

      // (optional) if you still want to handle other cases when pdf is false:
      const newWindow = window.open();
      if (newWindow) {
        newWindow.location.href = pdfUrl;
        newWindow.onload = () => {
          setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
        };
      }
      else {
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'document.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(pdfUrl);
      }
    }
    catch (err) {
      console.log(err);
      state.error = 'Eroare salvare comanda.'
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      commit('SET_IS_REQUEST', false)
    }
  },
  async make_pdf_custom_2 ({state, commit}, payload = {}) {
    try {
      commit('SET_IS_REQUEST', true)
      const url = `${api.download_pdf_custom_2}/${payload.id}`;
      commit('SET_REQ_IN_PROGRESS_NAME', 'download_pdf');
      const { data, headers } = await axios.get(url, { responseType: 'arraybuffer' });
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      commit('SET_IS_REQUEST', false)

      const pdfBlob = new Blob([data], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      if (payload.pdf === true) {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const fileName = _Get_Filename_From_Disposition(headers, `Deviz_${yyyy}-${mm}-${dd}.pdf`);

        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(pdfUrl);
        payload.clbk && payload.clbk();
        return;
      }

      const newWindow = window.open();
      if (newWindow) {
        newWindow.location.href = pdfUrl;
        newWindow.onload = () => {
          setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
        };
      }
    }
    catch (err) {
      console.log(err);
      state.error = 'Eroare salvare comanda.'
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      commit('SET_IS_REQUEST', false)
    }
  },
  async get_intrari_by_date_range ({commit}, range) {
    try {
      const {data} = await axios.post(api.intrari_by_date_range, range)
      commit('SET_RAR_ENTRIES', data)
    } catch (e) {
      console.log(e.response)
    }
  },
  async delete_comanda ({ state }, id) {
    try {
      const url = `${api.comenzi}/delete-comanda/${id}`;
      await axios.delete(url);
      await router.push('/comenzi');
    } catch (err) {
      console.log(err);
      state.error = 'Eroare stergere comanda.';
    }
  },
  async emit_deviz_invoice ({ commit, rootState }) {
    try {
      const comanda_id = router.currentRoute.params.id;
      commit('SET_REQ_IN_PROGRESS_NAME', 'generate_invoice');
      const invoice_data = Format_Invoice_Data(rootState);
      const { data, headers } = await axios.post(`${api.invoice}/${comanda_id}`, invoice_data, {
        responseType: 'blob',               // <— important
        headers: { Accept: 'application/pdf' }
      });
      commit('SET_REQ_IN_PROGRESS_NAME', '');

      // Try to get filename from Content-Disposition
      let filename = 'invoice.pdf';
      const cd = headers['content-disposition'];
      if (cd) {
        const match =
          /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(cd);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        }
      }
      // set deviz invoices
      commit('MARK_DEVIZ_INVOICED', filename);

      // Create a download
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
    catch (err) {
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      const message = await Extract_Axios_Error(err);
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      console.error('❌ Invoice Error:', message);
      this._vm.$toast.error(message || 'Oops!')
    }
  },
  async emit_smartbill_invoice ({ commit, rootState, getters }, { due_date } = {}) {
    // Pre-check pe FE: nu trimitem request pentru un deviz gol.
    if (getters.is_deviz_empty) {
      commit('SET_EMPTY_INVOICE_NOTICE', true);
      return null;
    }
    try {
      const comanda_id = router.currentRoute.params.id;
      commit('SET_REQ_IN_PROGRESS_NAME', 'smartbill_invoice');
      // due_date e opțional; dacă lipsește, BE pune automat data emiterii.
      const body = due_date ? { due_date } : {};
      const { data } = await axios.post(`${api.invoice_smartbill}/${comanda_id}`, body);
      commit('SET_REQ_IN_PROGRESS_NAME', '');

      const invoice_series = rootState.setari.settings.smartbill_series || '';
      commit('MARK_DEVIZ_SMARTBILL_INVOICED', {
        invoice_id: data.invoice_id,
        invoice_series,
        invoice_pdf_url: data.pdf_url || undefined,
      });
      return data;
    } catch (err) {
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      // BE răspunde 400 când comanda nu are articole (factură goală) — arătăm
      // modalul global „deviz gol" (nu toast). Restul erorilor: toast ca înainte.
      if (err?.response?.status === 400) {
        commit('SET_EMPTY_INVOICE_NOTICE', true);
        return null;
      }
      const message = await Extract_Axios_Error(err);
      this._vm.$toast.error(message || 'Eroare la generarea facturii SmartBill.');
      return null;
    }
  },
  async fetch_smartbill_invoice ({ commit }) {
    try {
      const comanda_id = router.currentRoute.params.id;
      commit('SET_REQ_IN_PROGRESS_NAME', 'smartbill_redownload');
      const { data, headers } = await axios.get(
        `${api.invoice_smartbill}/${comanda_id}`,
        { responseType: 'blob', headers: { Accept: 'application/pdf' } }
      );
      commit('SET_REQ_IN_PROGRESS_NAME', '');

      let filename = 'smartbill-invoice.pdf';
      const cd = headers['content-disposition'];
      if (cd) {
        const match = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(cd);
        if (match && match[1]) filename = decodeURIComponent(match[1]);
      }

      const blob = new Blob([data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err) {
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      const message = await Extract_Axios_Error(err);
      this._vm.$toast.error(message || 'Eroare la descărcarea facturii SmartBill.');
    }
  },
  async emit_oblio_invoice ({ commit, rootState, getters }) {
    // Pre-check pe FE: nu trimitem request pentru un deviz gol.
    if (getters.is_deviz_empty) {
      commit('SET_EMPTY_INVOICE_NOTICE', true);
      return null;
    }
    try {
      const comanda_id = router.currentRoute.params.id;
      commit('SET_REQ_IN_PROGRESS_NAME', 'oblio_invoice');
      // Ca la SmartBill: trimitem body minim, BE construiește client+produse din
      // comandă (și injectează CIF-ul + seria default).
      const { data } = await axios.post(`${api.invoice_oblio}/${comanda_id}`, {});
      commit('SET_REQ_IN_PROGRESS_NAME', '');

      const invoice_series = rootState.setari.settings.oblio_series || '';
      commit('MARK_DEVIZ_SMARTBILL_INVOICED', {
        invoice_id: data.invoice_id,
        invoice_series,
        invoice_pdf_url: data.pdf_url || undefined,
      });
      // Toast de succes, clicabil → duce la lista de facturi (ca la SmartBill).
      this._vm.$toast.success(getters.lang.facturi.emitSuccess, {
        onClick: () => router.push('/facturi'),
      });
      return data;
    } catch (err) {
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      if (err?.response?.status === 400) {
        commit('SET_EMPTY_INVOICE_NOTICE', true);
        return null;
      }
      const message = await Extract_Axios_Error(err);
      this._vm.$toast.error(message || 'Eroare la generarea facturii Oblio.');
      return null;
    }
  },
  async fetch_oblio_invoice ({ commit }) {
    try {
      const comanda_id = router.currentRoute.params.id;
      commit('SET_REQ_IN_PROGRESS_NAME', 'oblio_redownload');
      const { data, headers } = await axios.get(
        `${api.invoice_oblio}/${comanda_id}`,
        { responseType: 'blob', headers: { Accept: 'application/pdf' } }
      );
      commit('SET_REQ_IN_PROGRESS_NAME', '');

      let filename = 'oblio-invoice.pdf';
      const cd = headers['content-disposition'];
      if (cd) {
        const match = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(cd);
        if (match && match[1]) filename = decodeURIComponent(match[1]);
      }

      const blob = new Blob([data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err) {
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      const message = await Extract_Axios_Error(err);
      this._vm.$toast.error(message || 'Eroare la descărcarea facturii Oblio.');
    }
  },
  // Rutare după furnizorul activ (doar unul e conectat la un moment dat). Devizul
  // apelează aceste două și nu știe ce furnizor e în spate.
  emit_invoice ({ dispatch, rootGetters }, payload = {}) {
    return rootGetters.activeInvoiceProvider === 'oblio'
      ? dispatch('emit_oblio_invoice', payload)
      : dispatch('emit_smartbill_invoice', payload);
  },
  fetch_invoice ({ dispatch, rootGetters }) {
    return rootGetters.activeInvoiceProvider === 'oblio'
      ? dispatch('fetch_oblio_invoice')
      : dispatch('fetch_smartbill_invoice');
  },
  async clone_deviz_oferta_in_deviz ({ commit }, { id } ) {
    try {
      await axios.post(`${api.deviz}/clone-oferta-to-deviz`, { id_intrare: id });
      // show toast with success message
      this._vm.$toast.success('Deviz ofertă copiat în deviz!');
      // redirect to ?
      // await router.push('/comenzi');
    }
    catch (err) {
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      const message = await Extract_Axios_Error(err);
      commit('SET_REQ_IN_PROGRESS_NAME', '');
      console.error('❌ Invoice Error:', message);
      this._vm.$toast.error(message || 'Oops!')
    }
  },
  async download_receptie_pdf ({ commit }, id) {
    commit('SET_IS_REQUEST', true)
    try {
      const { data } = await axios.get(
        `${api.comenzi}/${id}/receptie-pdf`,
        {
          responseType: 'blob'
        }
      )
      window.open( URL.createObjectURL(data), '_blank')
    } catch (err) {
      console.error(err)
      this._vm.$toast?.error(
        'Eroare descarcare fisa receptie.'
      )
    } finally {
      commit('SET_IS_REQUEST', false)
    }
  },
  async download_fisa_mecanic_pdf ({ commit }, id) {
    commit('SET_IS_REQUEST', true)
    try {
      const { data } = await axios.get(
        `${api.comenzi}/${id}/fisa-mecanic-pdf`,
        {
          responseType: 'blob'
        }
      )
      window.open( URL.createObjectURL(data), '_blank')
    } catch (err) {
      console.error(err)
      this._vm.$toast?.error(
        'Eroare descarcare fisa mecanic.'
      )
    } finally {
      commit('SET_IS_REQUEST', false)
    }
  },
  async get_formular (_, { id, endpoint }) {
    try {
      const { data } = await axios.get(`${api.comenzi}/${id}/${endpoint}`)
      return data
    } catch (err) {
      console.log(err)
      this._vm.$toast && this._vm.$toast.error('Eroare incarcare formular.')
    }
  },
  async save_formular (_, { id, endpoint, payload }) {
    try {
      const { data } = await axios.put(`${api.comenzi}/${id}/${endpoint}`, payload)
      return data
    } catch (err) {
      console.log(err)
      this._vm.$toast && this._vm.$toast.error('Eroare salvare formular.')
    }
  },
  async download_formular_pdf ({ commit }, { id, endpoint }) {
    commit('SET_IS_REQUEST', true)

    try {
      const { data } = await axios.get(
        `${api.comenzi}/${id}/${endpoint}-pdf`,
        { responseType: 'blob' }
      )

      window.open(URL.createObjectURL(data), '_blank')

    } catch (err) {
      console.error(err)
      this._vm.$toast?.error(
        'Eroare descarcare formular PDF.'
      )
    } finally {
      commit('SET_IS_REQUEST', false)
    }
  },
  async download_comanda_pdf ({ commit, state }) {
    try {
      commit('SET_IS_REQUEST', true)
      const response = await axios.get(`${api.comenzi}/${state.comanda._id}/pdf`, {
        responseType: 'blob',
      })
      return response.data

    } catch (err) {
      console.error(err)
      throw err

    } finally {
      commit('SET_IS_REQUEST', false)
    }
  }
}

export const getters = {
  invoice_pdf_view_url: state => {
    const pdf_url = state.comanda.invoice_pdf_url;
    if (!pdf_url) return '';
    return window.location.origin + pdf_url;
  },
  // Spinner-ul butonului „Facturare" din deviz, agnostic de furnizor (SmartBill/Oblio).
  // in_progress_server_request_name trăiește în root state, nu în modulul comenzi.
  is_emitting_invoice: (state, getters, rootState) => {
    return ['smartbill_invoice', 'oblio_invoice'].includes(rootState.in_progress_server_request_name);
  },
  is_redownloading_invoice: (state, getters, rootState) => {
    return ['smartbill_redownload', 'oblio_redownload'].includes(rootState.in_progress_server_request_name);
  },
  empty_invoice_notice: state => state.emptyInvoiceNotice,
  // Deviz gol = nicio linie (manoperă/piese/materiale) cu denumire completată.
  // Folosit ca pre-check la facturare, ca să nu trimitem request pentru nimic.
  is_deviz_empty: state => {
    const d = state.deviz || {};
    const lines = [...(d.manopera || []), ...(d.parts || []), ...(d.materiale || [])];
    return !lines.some(o => o && String(o.denumire || '').trim());
  },
  get_deviz_oferta: state => {
    return state.deviz_oferta || {};
  },
  get_deviz_parts: state => {
    return state.deviz?.parts || [];
  },
  get_deviz_manopera: state => {
    return state.deviz?.manopera || [];
  },
  get_deviz_materiale: state => {
    return state.deviz?.materiale || [];
  },
  total_deviz_parts: (state, getters, rootState) => {
    const tva_rate = +(rootState.setari?.settings?.tarife?.tva || 0);
    return state.deviz.parts
      .reduce((acc, item) => {
        return acc + parseFloat(((_Parse_Number(item.total)) * 100 / (100 + tva_rate)).toFixed(2));
      }, 0);
  },
  total_deviz_manopera: (state, getters, rootState) => {
    const tva_rate = +(rootState.setari?.settings?.tarife?.tva || 0);
    return state.deviz.manopera
      .reduce((acc, item) => {
        return acc + parseFloat(((_Parse_Number(item.total)) * 100 / (100 + tva_rate)).toFixed(2));
      }, 0);
  },
  total_deviz_materiale: (state) => {
    return (state.deviz?.materiale || [])
      .reduce((acc, item) => {
        return acc + (_Parse_Number(item.durata) * _Parse_Number(item.pretUnitate));
      }, 0);
  },
  total_deviz_tva: (state, getters, rootState) => {
    const tva_rate = +(rootState.setari?.settings?.tarife?.tva || 0);
    const sum_parts = state.deviz.parts.reduce((acc, item) => {
      return acc + parseFloat(((_Parse_Number(item.total)) * tva_rate / (100 + tva_rate)).toFixed(2));
    }, 0);
    const sum_manopera = state.deviz.manopera.reduce((acc, item) => {
      return acc + parseFloat(((_Parse_Number(item.total)) * tva_rate / (100 + tva_rate)).toFixed(2));
    }, 0);
    return (sum_parts + sum_manopera).toFixed(2);
  },
  // The grand total (TVA included): direct sum of each row's own `total`
  // field across both tables. Deliberately NOT `total_deviz_parts +
  // total_deviz_manopera + total_deviz_tva` — that route splits every row
  // into two independently-rounded halves (fara-tva + tva) and re-sums
  // them, which is not guaranteed to reconstruct the original total to the
  // cent. Summing `item.total` directly can't drift from what's on screen.
  total_deviz: (state) => {
    const sum_parts = state.deviz.parts.reduce((acc, item) => acc + _Parse_Number(item.total), 0);
    const sum_manopera = state.deviz.manopera.reduce((acc, item) => acc + _Parse_Number(item.total), 0);
    return (sum_parts + sum_manopera).toFixed(2);
  },
  total_deviz_oferta_parts: (state) => {
    return state.deviz_oferta.parts
      .reduce((acc, item) => {
        return acc + (_Parse_Number(item.durata) * _Parse_Number(item.pretUnitate));
      }, 0);
  },
  total_deviz_oferta_manopera: (state) => {
    return state.deviz_oferta.manopera
      .reduce((acc, item) => {
        return acc + (_Parse_Number(item.durata) * _Parse_Number(item.pretUnitate));
      }, 0);
  },
  total_deviz_oferta_tva: (state, getters, rootState) => {
    const tva_rate = +(rootState.setari?.settings?.tarife?.tva || 0);
    const base = getters.total_deviz_oferta_parts + getters.total_deviz_oferta_manopera;
    return (base * tva_rate / 100).toFixed(2);
  },
}

function convertTimeToPrice (time, pricePerUnit) {
  const totalHours = _Parse_Number(time);
  const price = _Parse_Number(pricePerUnit);
  return Math.round(totalHours * price).toFixed(2);
}

function Format_Invoice_Data (rootState) {
  const { client } = rootState.comenzi?.comanda;
  const service = rootState.setari?.settings?.dateService;
  const settings = rootState.setari?.settings;
  const products = rootState.comenzi?.deviz?.manopera
    .map(o => ({
      name: o.denumire,
      price: +o.pretUnitate,
      measuringUnit: 'ore',
      currency: 'RON',
      vatName: 'Normala',
      vatPercentage: 0,
      vatIncluded: 1,
      quantity: o.durata,
      productType: 'Serviciu',
    }));

  return {
    cif: service.cui,
    client: {
      cif: client.cui,
      name: client.numeFirma,
      state: client.state,
      city: client.city,
      vatPayer: true
    },
    issueDate: new Date().toISOString().slice(0,10),
    seriesName: settings.serieFactura,
    language: 'RO',
    precision: 2,
    currency: 'RON',
    products,
    workStation: 'Sediu',
    useStock: 0
  };
}

async function Extract_Axios_Error (err) {
  if (err?.response) {
    const data = err.response.data;

    // If the server sent JSON but we requested 'blob', parse it
    if (data instanceof Blob) {
      const text = await data.text();
      try {
        const json = JSON.parse(text);
        return json.message || text;
      } catch {
        return text;
      }
    }

    if (typeof data === 'string') {
      try {
        const json = JSON.parse(data);
        return json.message || data;
      } catch {
        return data;
      }
    }

    if (data?.message) return data.message;
    return `HTTP ${err.response.status}`;
  }
  return err?.message || String(err);
}